import { buildImgUrl } from "@/utils";

// Préchauffage des vignettes de la grille Collection (opt.4, 29/07).
// Objectif : ZÉRO attente à l'ouverture de la Collection, même à la toute
// première visite. On télécharge les 51 vignettes (~800 Ko) en tâche de
// fond pendant que l'utilisateur est sur la landing ; le service worker
// (StaleWhileRevalidate) et le cache navigateur les servent ensuite
// instantanément.
// Garde-fous : jamais sur le chemin critique (requestIdleCallback), petits
// lots de 4 pour ne pas saturer la bande passante mobile, et on s'abstient
// si l'utilisateur a activé l'économiseur de données.
let done = false;

export function prefetchCollectionThumbs(animalIds) {
  if (done || !animalIds.length) return;
  if (navigator.connection && navigator.connection.saveData) return;
  done = true;

  const urls = animalIds.map((id) =>
    buildImgUrl(`Animax/${id}/main_no-bg_thumb.webp`)
  );
  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 2000));

  idle(() => {
    const BATCH = 4;
    let i = 0;
    const next = () => {
      if (i >= urls.length) return;
      const batch = urls.slice(i, i + BATCH);
      i += BATCH;
      Promise.allSettled(
        batch.map(
          (src) =>
            new Promise((resolve) => {
              const img = new Image();
              img.onload = resolve;
              img.onerror = resolve;
              img.decoding = "async";
              img.src = src;
            })
        )
      ).then(next);
    };
    next();
  });
}
